import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const DocumentText = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/document-text">
        <g id="document-text">
          <path
            id="Vector"
            d="M9.9987 15.1667H5.9987C2.3787 15.1667 0.832031 13.62 0.832031 10V6.00004C0.832031 2.38004 2.3787 0.833374 5.9987 0.833374H9.33203C9.60536 0.833374 9.83203 1.06004 9.83203 1.33337C9.83203 1.60671 9.60536 1.83337 9.33203 1.83337H5.9987C2.92536 1.83337 1.83203 2.92671 1.83203 6.00004V10C1.83203 13.0734 2.92536 14.1667 5.9987 14.1667H9.9987C13.072 14.1667 14.1654 13.0734 14.1654 10V6.66671C14.1654 6.39337 14.392 6.16671 14.6654 6.16671C14.9387 6.16671 15.1654 6.39337 15.1654 6.66671V10C15.1654 13.62 13.6187 15.1667 9.9987 15.1667Z"
          />
          <path
            id="Vector_2"
            d="M14.6654 7.1667H11.9987C9.7187 7.1667 8.83203 6.28003 8.83203 4.00003V1.33337C8.83203 1.13337 8.95203 0.9467 9.1387 0.873366C9.32536 0.793366 9.5387 0.840033 9.68536 0.980033L15.0187 6.31337C15.1587 6.45337 15.2054 6.67337 15.1254 6.86003C15.0454 7.0467 14.8654 7.1667 14.6654 7.1667ZM9.83203 2.54003V4.00003C9.83203 5.72003 10.2787 6.1667 11.9987 6.1667H13.4587L9.83203 2.54003Z"
          />
          <path
            id="Vector_3"
            d="M8.66797 9.16663H4.66797C4.39464 9.16663 4.16797 8.93996 4.16797 8.66663C4.16797 8.39329 4.39464 8.16663 4.66797 8.16663H8.66797C8.9413 8.16663 9.16797 8.39329 9.16797 8.66663C9.16797 8.93996 8.9413 9.16663 8.66797 9.16663Z"
          />
          <path
            id="Vector_4"
            d="M7.33464 11.8334H4.66797C4.39464 11.8334 4.16797 11.6067 4.16797 11.3334C4.16797 11.06 4.39464 10.8334 4.66797 10.8334H7.33464C7.60797 10.8334 7.83464 11.06 7.83464 11.3334C7.83464 11.6067 7.60797 11.8334 7.33464 11.8334Z"
          />
        </g>
      </g>
    </svg>
  );
};

DocumentText.displayName = 'DocumentText';
